import { useLocalization } from '../context/LocalizationContext';
import { getBuiltInTranslation, BuiltInTranslations } from '../constants/builtInTranslations';

/**
 * Custom hook for accessing built-in translations
 *
 * This hook combines the current localization context with the built-in translations
 * to provide localized text that's not available from the API settings.
 */
export const useBuiltInTranslations = () => {
  const { config } = useLocalization();

  /**
   * Get a built-in translation based on the current language
   */
  const t = (key: keyof BuiltInTranslations): string => {
    return getBuiltInTranslation(key, config.language);
  };

  return { t };
};
